





























































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getConfig } from '@/web/utils/configuration';
import BioShareModal from '@/web/components/bio/BioShareModal.vue';
import BioUpgradeModal from '@/web/components/bio/BioUpgradeModal.vue';
import HMButton from '@/web/components/common/HMButton.vue';

export default Vue.extend({
  name: 'BioTopBar',
  components: { HMButton },
  data() {
    return {
      showOptions: false,
      showMobileOptions: false,
      showMobileMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      userFullName: 'user/userFullName',
      teacher: 'user/teacher',
    }),
    isBio() {
      return this.teacher?.is_bio;
    },
    config() {
      return getConfig();
    },
    pageName() {
      const pages = {
        'bio-link': this.$t('BIO.LABEL.LINKS'),
        'bio-design': this.$t('BIO.LABEL.DESIGN'),
        'bio-settings': this.$t('BIO.LABEL.SETTINGS'),
      };

      return pages[this.$route.name] || this.$t('BIO.LABEL.MENU');
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch(`user/logout`);
      this.$router.replace('/login');
    },
    openShareModal() {
      this.$modal.show(BioShareModal);
    },
    openUpgradeModal() {
      this.$modal.show(BioUpgradeModal);
    },
  },
});
